import { render, staticRenderFns } from "./SettingsLocalisation.vue?vue&type=template&id=3499744a&"
import script from "./SettingsLocalisation.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports